const SqftIcon = ({ color = "#31493C", ...props }) => (
  <svg
    width="20"
    height="17"
    viewBox="0 0 20 17"
    fill="none"
    {...props}
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.39844 15.6861L3.89277 1.40039H16.3644L18.8588 15.6861H1.39844Z"
      stroke={color}
      strokeWidth="1.19048"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.19141 12.1152H18.0645"
      stroke={color}
      strokeWidth="1.19048"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.98633 8.54297H17.272"
      stroke={color}
      strokeWidth="1.19048"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.7793 4.97266H16.4778"
      stroke={color}
      strokeWidth="1.19048"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.1289 1.40039V15.6861"
      stroke={color}
      strokeWidth="1.19048"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.95415 1.79688L5.76367 15.2889"
      stroke={color}
      strokeWidth="1.19048"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3027 1.79688L14.4932 15.2889"
      stroke={color}
      strokeWidth="1.19048"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SqftIcon;
